import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=dc7f8900&scoped=true&lang=pug&"
var script = {}
import style0 from "./terms.vue?vue&type=style&index=0&id=dc7f8900&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7f8900",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc7f8900')) {
      api.createRecord('dc7f8900', component.options)
    } else {
      api.reload('dc7f8900', component.options)
    }
    module.hot.accept("./terms.vue?vue&type=template&id=dc7f8900&scoped=true&lang=pug&", function () {
      api.rerender('dc7f8900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/terms.vue"
export default component.exports